export default __webpack_public_path__ + "static/PVH_poppy-01-8e46ae054e46dc53eed40ce1c30a00e5.png";